(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
var StyledElement = styled('div').withConfig({
  displayName: "HtmlElement__StyledElement",
  componentId: "sc-h9txmu-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.borderTop && "border-top: ".concat(props.borderTop, ";");
}, function (props) {
  return props.borderRight && "border-right: ".concat(props.borderRight, ";");
}, function (props) {
  return props.borderBottom && "border-bottom: ".concat(props.borderBottom, ";");
}, function (props) {
  return props.borderLeft && "border-left: ".concat(props.borderLeft, ";");
}, function (props) {
  return props.paddingTop && "padding-top: ".concat(props.paddingTop, ";");
}, function (props) {
  return props.paddingRight && "padding-right: ".concat(props.paddingRight, ";");
}, function (props) {
  return props.paddingBottom && "padding-bottom: ".concat(props.paddingBottom, ";");
}, function (props) {
  return props.paddingLeft && "padding-left: ".concat(props.paddingLeft, ";");
}, function (props) {
  return props.marginTop && "margin-top: ".concat(props.marginTop, ";");
}, function (props) {
  return props.marginRight && "margin-right: ".concat(props.marginRight, ";");
}, function (props) {
  return props.marginBottom && "margin-bottom: ".concat(props.marginBottom, ";");
}, function (props) {
  return props.marginLeft && "margin-left: ".concat(props.marginLeft, ";");
}, function (props) {
  return props.textAlign && "text-align: ".concat(props.textAlign, ";");
}); // eslint-disable-next-line react/display-name

var HtmlElement = forwardRef(function (props, ref) {
  var tagName = props.tagName,
      as = props.as,
      children = props.children,
      testSelector = props.testSelector,
      rest = _objectWithoutProperties(props, ["tagName", "as", "children", "testSelector"]);

  var dataTestSelector = testSelector ? {
    'data-test-selector': testSelector
  } : {};
  var forwardedRef = ref ? {
    ref: ref
  } : {};
  return React.createElement(StyledElement, _extends({
    as: as || tagName
  }, forwardedRef, rest, dataTestSelector), children);
});
HtmlElement.defaultProps = {
  tagName: 'div'
};
var _default = HtmlElement;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledElement, "StyledElement", "/home/vsts/work/1/s/src/components/base/HtmlElement.js");
  reactHotLoader.register(HtmlElement, "HtmlElement", "/home/vsts/work/1/s/src/components/base/HtmlElement.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/base/HtmlElement.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();